import React,{ useState } from "react"
import { Button, Tooltip } from "antd"
import { StarTwoTone , RobotOutlined,ThunderboltOutlined } from "@ant-design/icons"
import { AITagGenerationWizard } from "components";
import AIButton from "components/molecules/AIButton";
interface errorObject {
    message: string
    code: string
    success: boolean
  }
interface AIGenerateTagButtonProps {
    generateTagsWithAI: (
        payload:{ prompt: string, numTags: number }
    ) => Promise<Array<{ name: string; description: string }>>
    createTags?: (
        tags: Array<{ tagName: string; tagDescription: string; businessAreaId: string }>
    ) => Promise<void>
    isGeneratingTags: boolean
    isCreatingTags: boolean
    businessAreaList: Array<{ businessAreaId: string; name: string }>
    aiGeneratedTags?: any
    resetAiGeneratedTags?: () => void;
    disabled?: boolean
    openAIKeyExists?: boolean
    aiGeneratedErrors?: errorObject | null
    bulkCreateErrors?: errorObject | null
    DataTagList?:Array<any>
    rephraseWithAI?: (payload:{tagName:string,prevDescription:string}) => Promise<{newDescription:string}>
    isRephrasing?: boolean
    rephrasedDataTag?:any
}

const AIGenerateTagButton: React.FC<AIGenerateTagButtonProps> = ({
    generateTagsWithAI,
    createTags,
    isGeneratingTags,
    isCreatingTags,
    businessAreaList,
    aiGeneratedTags,
    resetAiGeneratedTags,
    openAIKeyExists,
    disabled,
    aiGeneratedErrors,
    bulkCreateErrors,
    DataTagList,
    rephraseWithAI,
    isRephrasing,
    rephrasedDataTag,
}) => {
    const [wizardVisible, setWizardVisible] = useState(false)

    const showWizard = () => {
        setWizardVisible(true)
    }
    const hideWizard = () => {
        setWizardVisible(false)
    }
    return (
        <>
            <AIButton
                onClick={showWizard}
                disabled={disabled || !openAIKeyExists}
                tooltipTitle="Generate tags with AI"
                disabledTooltipTitle="OpenAI API key required (Bring Your Own License - BYOL). Please configure your key in settings"
                buttonText="AI Tags"
            />
            <AITagGenerationWizard
                visible={wizardVisible}
                onClose={hideWizard}
                generateTagsWithAI={generateTagsWithAI}
                createTags={createTags}
                isGeneratingTags={isGeneratingTags}
                isCreatingTags={isCreatingTags}
                businessAreaList={businessAreaList}
                aiGeneratedTags={aiGeneratedTags}
                resetAiGeneratedTags={resetAiGeneratedTags}
                aiGeneratedErrors={aiGeneratedErrors}
                bulkCreateErrors={bulkCreateErrors}
                DataTagList={DataTagList}
                rephraseWithAI={rephraseWithAI}
                isRephrasing={isRephrasing}
                rephrasedDataTag={rephrasedDataTag}
            />
        </>
    )
}

export default React.memo(AIGenerateTagButton)